var map = {
	"./base/errors/errors.less": 191,
	"./errors/errors.less": 192,
	"./templates/events/applicantAuthLink.less": 22,
	"./templates/events/registrationFormControllerContainer.less": 59,
	"./templates/events/timer.less": 60,
	"./templates/news/entry.less": 193,
	"./templates/news/list.less": 194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;